import script from "./UserAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAddress.vue?vue&type=script&setup=true&lang=js"

import "./UserAddress.vue?vue&type=style&index=0&id=45f27fa9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45f27fa9"]])

export default __exports__